var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo } from 'react';
import { ProgressBar } from '../../atoms/progress-bar';
import { Text, TextVariants } from '../../atoms/text';
import { Container, ContainerDisplays, ContainerFlexAlignItems, ContainerFlexDirections, ContainerFlexGaps, ContainerFlexJustifyContents, ContainerFlexWraps, ContainerRoles } from '../../templates/container';
var Bar = memo(function (_a) {
    var label = _a.label, value = _a.value, scale = _a.scale, ariaLabel = _a["aria-label"], _b = _a.fluid, fluid = _b === void 0 ? true : _b;
    var barContainerConfig = {
        display: ContainerDisplays.Flex,
        flexGap: ContainerFlexGaps.Size_3,
        flexAlignItems: ContainerFlexAlignItems.Center,
        flexJustifyContent: ContainerFlexJustifyContents.SpaceBetween,
        'aria-label': ariaLabel,
        'aria-valuenow': "".concat(value),
        role: ContainerRoles.Meter
    };
    var progressBarConfig = {
        value: value,
        scale: scale,
        fluid: fluid
    };
    return (React.createElement(Container, __assign({}, barContainerConfig),
        React.createElement(Container, { width: "12rem" },
            React.createElement(Text, { content: label, variant: TextVariants.Body2 })),
        React.createElement(ProgressBar, __assign({}, progressBarConfig))));
});
var B = function (_a) {
    var profiles = _a.profiles, fluid = _a.fluid;
    var containerConfig = {
        display: ContainerDisplays.Flex,
        flexGap: ContainerFlexGaps.Size_2,
        flexDirection: ContainerFlexDirections.Column,
        flexWrap: ContainerFlexWraps.NoWrap
    };
    return (React.createElement(Container, __assign({}, containerConfig), profiles.map(function (_a, index) {
        var label = _a.label, value = _a.value, scale = _a.scale;
        return (React.createElement(Bar, { key: "".concat(index, "-").concat(label), label: label, value: value, scale: scale, fluid: fluid, "aria-label": "bar-".concat(value, "-out-of-").concat(scale) }));
    })));
};
export { B as Bars };
